import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from '@entur/loader'
import { Label } from '@entur/typography'
import { space } from '@entur/tokens'
import { CustomFilterChip, FilterChipInfo } from './custom-filter-chip'
import { useOnlyUpdateableEffect } from '../../../hooks/common-hooks'
import { FetchState } from '../../../api-clients/api-types'
import { useEmployee } from '../../../contexts/employee-context'
import { useFamilyMembers } from '../../../contexts/family-members-context'

type TravelTypeFilterFieldProps = {
  travelTypes: string[]
  setTravelTypes: (travelTypes: string[]) => void
}

export const TravelerFilterField: React.FC<TravelTypeFilterFieldProps> = ({ setTravelTypes }) => {
  const { employee } = useEmployee()
  const { familyMembersResponse } = useFamilyMembers()
  const [travelers, setTravelers] = useState<FilterChipInfo[]>([])
  const displayFlex = { display: 'flex', gap: space.rem.medium + 'rem' }

  useOnlyUpdateableEffect(() => {
    const travelTypes = travelers.filter((chip) => chip.isChecked).map((chip) => chip.name)
    setTravelTypes(travelTypes)
  }, [travelers])

  const updateFilter = useCallback(
    (filterInfo: FilterChipInfo) => {
      setTravelers(
        travelers.map((value) => {
          if (value.value === filterInfo.value) return filterInfo
          else return value
        })
      )
    },
    [travelers]
  )

  useEffect(() => {
    if (familyMembersResponse?.status === FetchState.SUCCESS) {
      const familyMembers = familyMembersResponse.data.map((familyMember) => {
        return {
          value: familyMember.id,
          name: `${familyMember.firstName} ${familyMember.surname}`,
          isChecked: false,
        }
      })
      setTravelers([
        { value: employee.id, name: `${employee.firstName} ${employee.surname}`, isChecked: false },
        ...familyMembers,
      ])
    }
  }, [employee.firstName, employee.id, employee.surname, familyMembersResponse])

  return (
    <div data-cy="traveler-filter-field">
      {familyMembersResponse?.status === FetchState.LOADING && <Loader>Henter familiemedlemmer</Loader>}
      {familyMembersResponse?.status === FetchState.SUCCESS && (
        <>
          <Label>Reisende</Label>
          <div style={displayFlex} data-cy="traveler-filter-chips">
            {travelers.map((traveler) => {
              return (
                <CustomFilterChip
                  key={traveler.value}
                  filterChipInfo={traveler}
                  setFilterChipInfo={updateFilter}
                />
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}
